export enum EPageStatus {
	none = "none",
	active = "active",
	inactive = "inactive",
	initializing = "initializing"
}